module.exports = __webpack_public_path__ + "static/img/noMesge.6b7e13c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noMesge.jpg
// module id = 5BTS
// module chunks = 2